import cn from 'classnames';
import { FC } from 'react';
import { FaArrowUp } from 'react-icons/fa6';
import { IconButton } from '../../../../components/icon-button/icon-button';
import { pageKey } from '../../../../helpers/path';
import { useLang } from '../../../../hooks/use-lang';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { SortType } from '../../../../types/props';
import { sortKey } from '../../helpers';
import s from './table-sorter.module.css';

interface Props {
  name: string;
}

const rec: Record<SortType, SortType | undefined> = {
  asc: 'desc',
  desc: undefined,
};

export const TableSorter: FC<Props> = ({ name }) => {
  const { t } = useLang();
  const { getQueryParams, addQueryParams } = useQueryParams();
  const state = getQueryParams()[sortKey];
  const parsed = JSON.parse(state || '{}');
  const current = parsed[name] as SortType;

  const handleClick = () => {
    const newState = current ? rec[current] : 'asc';
    const value = JSON.stringify({ [name]: newState });
    addQueryParams({ [sortKey]: newState ? value : undefined, [pageKey]: '1' });
  };

  return (
    <IconButton
      onClick={handleClick}
      variant="ghost"
      size="sm"
      className={cn(s.feature, s[current])}
      tooltip={t(current === 'asc' ? 'Сортировать по возрастанию' : 'Сортировать по убыванию')}
    >
      <FaArrowUp />
    </IconButton>
  );
};
